export const focusBarcodeScannerInput = () => {
	const input = document.getElementById("customId");
	if (input) {
		input.focus();
	}
};
